"use client";

import React, { useEffect, useState } from 'react';
import { Badge } from "flowbite-react";
import { Button, Select, Table } from 'antd'
import { Link, useLoaderData } from 'react-router-dom';
import Pagination from '../../globalComponents/Pagination';
import Axios from '../utils/axios';

const columns = [
  {
    title: 'Number',
    dataIndex: 'number',
    key: 'number',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Bill Date',
    dataIndex: 'bill_date',
    key: 'bill_date',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <>{new Date(record.bill_date).toLocaleDateString()}</>
  },
  
  {
    title: 'Vendor',
    dataIndex: 'vendor',
    key: 'vendor',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    className: 'whitespace-wrap font-medium dark:text-white',
    render: (_, record) => <Badge className={record.status === 'posted' ? "text-green-950 bg-green-100 w-max" : "text-red-950 bg-red-100 w-max"}>{record.status}</Badge>
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/accounting/bills/' + record.number.replaceAll('/', '-')}>
        Edit
      </Link>
    )
  }
]


const options = []
for (let i = 10; i < 36; i++) {
  options.push({
    value: i.toString(36) + i,
    label: i.toString(36) + i
  })
}
const handleChange = (value) => {
  console.log(`Selected: ${value}`)
}



const VendorBills = () => {
  const bills = useLoaderData();
  const [searchBills, setSearchBills] = useState({bills: bills.bills, totalRows: bills.totalRows});

  const [paginations, setPaginations] = useState({pageSize: 100, page: 1});


  async function fetchUserList(pagination_) {

    return Axios(`vendor-bills/search?pagination=${JSON.stringify(pagination_)}`)
      .then((response) => response.data)
      .then((res) => {
        setSearchBills(res); 
      });
  }

  useEffect(() => {
    // const totalPages = Math.ceil(paginations.total / paginations.pageSize);
    // if (paginations.page < 1) setPaginations({...paginations, page: 1});
    // if (paginations.page > totalPages) setPaginations({...paginations, page: totalPages});
    const offset = (paginations.page - 1) * paginations.pageSize;
    let pagination_ = {offset, pageSize: paginations.pageSize};
    // let filters = {search: {by: searchBy, values: search, filters: selectedFilters}};
    fetchUserList(pagination_);
  },[paginations])

  return (
    <div>

      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Bills</h3>
        <div className=' bg-white dark:bg-gray-900'>

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            onChange={handleChange}
            className='w-96'
            options={options}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/accounting/bills/new'} className='w-full'>
              New
            </Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination paginations={paginations} total={searchBills.totalRows} setPaginations={setPaginations} />
          </div>
        </div>
      </div>
      <Table
        dataSource={searchBills.bills}
        rowKey={'number'}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
      />
    </div>
  )
}

export default VendorBills;